import { render } from "./SlaSettings.vue?vue&type=template&id=485fd09e&scoped=true"
import script from "./SlaSettings.vue?vue&type=script&lang=js"
export * from "./SlaSettings.vue?vue&type=script&lang=js"

import "./SlaSettings.vue?vue&type=style&index=0&id=485fd09e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485fd09e"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QTable});
